import { ContentDetails } from "./Audio";

export interface ResponseMessage {
    message: string;
}
export interface AvailableCredits {
    availableCredits: number;
}
export interface AddToCart {
    cartId: string;
    messages: string;
    orderId: string;
    processingFee: number;
    shippingFee: number;
    subtotal: number;
    tax: number;
    total: number;
}

export interface ConfirmContentPurchase {
    cartId: any;
    messages: string;
    orderId: string;
    processingFee: number;
    shippingFee: number;
    subtotal: number;
    tax: number;
    total: number;
}

export interface Members {
    member_id: string;
    first_name: string;
    last_name: string;
}

export interface MembersGroup {
    group_name: string;
    members: Members[];
}

export interface GiftRemainingQuantity {
    sku: string;
    quantity: number;
}

export interface PurchasableGift {
    nid: string;
    title: string;
    sku_id: string;
    is_redeemable_by_tokens: boolean;
    release_date: string;
    image_file_name: string;
    image_url_postfix: string;
    image_url_prefix: string;
    publish_free: boolean;
    content_price: number;
    description: string;
    number_of_tokens: number;
}

export interface GiftToSend {
    nid: string;
    title: string;
    sku_id: string;
    description: string;
    release_date: string;
    acquired_date: string;
    quantity: number;
    image_file_name: string;
    image_url_prefix: string;
    image_url_postfix: string;
}

export interface AcquiredDate {
    [key: string]: string;
}

export interface SendGift {
    nid: string;
    sku: string;
    category: string;
    title: string;
}

export enum AllTabs {
    AUDIOS = "Audio",
    VIDEOS = "Video",
    COURSES = "Course",
}

export interface GiftGiven {
    nid: string;
    title: string;
    sku_id: string;
    description: string;
    sending_date: string;
    content_type: string;
    image_file_name: string;
    image_url_prefix: string;
    image_url_postfix: string;
}

export interface ReceivedGift {
    nid: string;
    title: string;
    sku_id: string;
    is_redeemable_by_tokens: boolean;
    release_date: string;
    no_of_files: string;
    image_file_name: string;
    image_url_prefix: string;
    image_url_postfix: string;
    publish_free: string;
    content_price: number;
    description: string;
    number_of_tokens: number;
    is_purchased: boolean;
    media_url_prefix: string;
    media_url_postfix: string;
    media_file_name: string;
    content_item_type_name: string;
    sender: {
        member_id: string;
        first_name: string;
        last_name: string;
        sending_date_time: string;
    };
    isReceived: boolean;
    played: string;
}

export interface GiftWithMedia extends ReceivedGift, ContentDetails {}

export type ContentType =
    | "MP3"
    | "GiftMP3"
    | "GiftProsMP3"
    | "Video"
    | "GiftVideo"
    | "GiftProsVideo";
